import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import "./style";
import api, { http } from "../../service";
import { InputItem, Toast, Modal, Checkbox, Icon } from "antd-mobile";
import Process from "./Process";
import AreaCode from "../../components/AreaCode";
import {
  STATIC_SRC,
  TOKEN,
  sendVerifyCode,
  registerAccountByVerifyCode,
  //verifyPhoneNumber, 海外号码不好判断，服务端判断
  ENV,
  API_TOKEN_HOST
} from "utils";
import { formatSeconds } from "utils/common";
import { isTest } from "utils";
import WxShare from "utils/wxShare";
import Album from "./Album";

// 替换黑色地图的展示模版图片
import v61 from "assets/v6/1.jpg";
import v62 from "assets/v6/2.jpg";
import v63 from "assets/v6/3.jpg";
import v64 from "assets/v6/4.jpg";
import v65 from "assets/v6/5.jpg";
import v66 from "assets/v6/6.jpg";
import v67 from "assets/v6/7.jpg";
import v68 from "assets/v6/8.jpg";
import v69 from "assets/v6/9.jpg";
import v610 from "assets/v6/10.jpg";
import v611 from "assets/v6/11.jpg";

// 123 礼包活动展示模版图片
import banner3 from "assets/v3/1.png";
import inputBg3 from "assets/v3/2.png";
import album31 from "assets/v3/3.png";
import album32 from "assets/v3/4.png";
import album33 from "assets/v3/5.png";
import album34 from "assets/v3/6.png";
import album35 from "assets/v3/7.png";
import notice3 from "assets/v3/8.png";

// VIP+优惠券通用模板
import banner4 from "assets/v4/41.png";
import inputBg4 from "assets/v4/42.png";
import album41 from "assets/v4/43.png";
import album42 from "assets/v4/44.png";
import album43 from "assets/v4/45.png";
import album44 from "assets/v4/46.png";
// import couponBg from "assets/v4/47.png";
import notice4 from "assets/v4/48.png";
import vipLogo from "assets/v4/vip4.png";

// 思想跨年活动模板
import banner5 from "assets/v5/51.png";
import inputBg5 from "assets/v5/52.png";
import album51 from "assets/v5/53.png";
import album52 from "assets/v5/54.png";
import album53 from "assets/v5/55.png";
import album54 from "assets/v5/56.png";
import album55 from "assets/v5/57.png";
import notice5 from "assets/v5/59.png";
import notice52 from "assets/v5/59-2.png";
import vipLogo5 from "assets/v5/vipLogo5.png";

const playBtn = require("assets/play_btn.png");
const pauseBtn = require("assets/pause_btn.png");

// 输入组件配色
const inputCompColorArr = ["", "red", "orange", "blue"];

let devHost = STATIC_SRC;
if (~window.location.host.indexOf("sunshy")) {
  devHost = "";
}
const AreaCodeComp = ({ code, showDrawer }) => (
  <div className="area-code-box" onClick={showDrawer}>
    <span>{code}</span>
    <Icon type="down" />
  </div>
);
// const curAppType = getAppType();
const globalToastInfo = "立即输入手机领取吧~立享双重福利！";
const globalToast = "立即输入手机领取吧~";
// 手机系统
const deviceId = window.navigator.userAgent.indexOf("iPhone") > -1 ? 200 : 100;
//input 背景样式
const inputBgInfo = {
  coupon: {
    paddingTop: "58.667%",
    background: `url(${inputBg3}) no-repeat
    center/cover`
  },
  sign: {
    paddingTop: "58.667%",
    background: `url(${v62}) no-repeat
    center/cover`
  },
  common: {
    paddingTop: "65.6%",
    background: `url(${inputBg4}) no-repeat
    center/cover`
  },
  inputBg5: {
    paddingTop: "65%",
    background: `#710000 url(${devHost + inputBg5}) no-repeat
    center/cover`
  }
};
// 输入组件配色
const tempStyleDetailArr = [
  {},
  {
    mainColor: "#FF4713",
    wordColor: "#999",
    backgroundColor: "rgba(255, 255, 255, 0.85)"
  },
  {
    mainColor: "#FF943E",
    wordColor: "#fff",
    backgroundColor: "rgba(25,31,37,0.7)"
  },
  {
    mainColor: "#2962FF ",
    wordColor: "#999",
    backgroundColor: "rgba(255, 255, 255, 0.85)"
  }
];
const inputColorArr = [
  {},
  {
    mainColor: "#FF4713",
    wordColor: "#999"
  },
  {
    mainColor: "#FF943E",
    wordColor: "#fff"
  },
  {
    mainColor: "#2962FF",
    wordColor: "#999"
  }
];
const maskBgArr = [
  {},
  {
    backgroundColor: "rgba(0,0,0,0.85)",
    trackMainColor: "#fff",
    trackTitleColor: "#fff"
  },
  {
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    color: "#eee",
    trackMainColor: "#7D8182",
    trackTitleColor: "#191F25"
  },
  {
    backgroundColor: "rgba(255, 255, 255, 0)",
    trackMainColor: "#fff",
    trackTitleColor: "#fff"
  }
];

//口播声音logo大小
const trackLogoSizeArr = [
  "",
  { width: "72px", height: "72px" },
  { width: "56px", height: "56px" }
];
//口播声音play-btn大小
const playLogoSizeArr = [
  "",
  { width: "36px", height: "36px" },
  { width: "30px", height: "30px" }
];

//图片列表
let albumList = [v63, v64, v65, v66, v67, v68, v69, v610];
//页面信息cookie
const pageInfoKey =
  ENV === "test"
    ? "4_experience_vip_xm_c_id"
    : ENV === "uat"
    ? "6_experience_vip_xm_c_id"
    : "1_experience_vip_xm_c_id";
const pageInfoKey2 =
  ENV === "test"
    ? "4_experience_vip_xm_au_id"
    : ENV === "uat"
    ? "6_experience_vip_xm_au_id"
    : "1_experience_vip_xm_au_id";

//用户ID，连续包月商品ID(itemId), appkey, 开放平台商品ID(openItemId)
const openItemInfo = decodeURIComponent(Cookies.get(pageInfoKey));
const [openItemId, appkey, productType] = openItemInfo
  ? openItemInfo.split("&")
  : [];
const activityUrlId = Cookies.get(pageInfoKey2) || 0;
console.log("activityUrlId", activityUrlId);
let userId = null;
// 主站七天免费会员商品Id
const mainItemId = "1010500100000301396";
//const itemId = ENV === "test" ? "1010500100000120516" : "1010500100000101248";
const itemId = ENV === "test" ? "1010500100000222248" : "1010500100000101248";
const itemId_8day = "1010500100000302720";
const userInfo = Cookies.get(TOKEN);
if (userInfo) {
  userId = userInfo.split("&")[0];
}

// 声音组件中声音详情索引

// 播放器播放声音
let gAudio = new Audio();

@withRouter
class GetVip extends Component {
  state = {
    phone: "",
    code: "",
    picCode: "",
    verifyCodePic: "",
    verifyCodePicId: "",
    btnTxt: "发送验证码",
    sending: false,
    modal: false,
    type: "",
    expire: "",
    isNeedSign: false,
    selRules: true,
    templateType: "",
    templateData: [],
    showModal: false,
    title: "",
    content: "",
    status: "",
    trackDetails: [],
    playing: false,
    curTrackInfo: null,
    curPos: 0,
    curTime: 0,
    guideToApp: 1,
    activityId: "",
    couponDetails: [],
    displayStatus: "",
    areaCode: "+86",
    selectAreaCode: false,
    jumpDetail: {}
  };
  showDrawer = () => {
    //console.log("show");
    this.setState({ selectAreaCode: true });
  };
  hideDrawer = code => {
    // console.log("code", code);
    if (code !== 0) {
      this.setState({ areaCode: code });
    }
    this.setState({ selectAreaCode: false });
  };
  onChange = value => {
    if(value){
      const phone = value.replace(/\s*/g,'');
      this.setState({ phone });
    }
  };
  onCodeChange = code => {
    this.setState({ code });
  };
  onPicCodeChange = picCode => {
    this.setState({ picCode });
  };
  getCode = async e => {
    e.preventDefault();
    const { phone, isNeedSign, activityId, areaCode } = this.state;
    if (!phone) {
      Toast.info("请输入正确手机号", 2, null, false);
      return;
    }
    let phoneArea = phone;
    if (areaCode !== "+86") {
      phoneArea = areaCode.substr(1) + "-" + phone;
    }
    if (this.state.sending) {
      return;
    }
    if (!isNeedSign) {
      //  不需要签约包月领取礼包判断
      const { code, message, data } = await http.get(api.IS_RECEIVED_VIP, {
        mobile: phoneArea,
        activity_id: activityId
      });
      if (!code) {
        if (data) {
          Toast.info(message || "您已经领过礼包了～", 2, null, false);
          return;
        }
      } else {
        Toast.info(message || "接口出错", 2, null, false);
        return;
      }
    }
    let sec = 60;
    let timer = null;
    this.setState({
      btnTxt: <span style={{ color: "#999" }}>{sec}s后再发送</span>,
      sending: true
    });
    timer = setInterval(() => {
      sec--;
      this.setState({
        btnTxt: <span style={{ color: "#999" }}>{sec}s后再发送</span>
      });
      if (sec <= 0) {
        clearInterval(timer);
        this.setState({ btnTxt: "发送验证码", sending: false });
      }
    }, 1000);
    //发验证码
    console.log(phoneArea);
    sendVerifyCode(phoneArea).then(res => {
      // console.log("res", res);
      if (res.ret === 0) {
        Toast.info(res.msg || "发送成功", 2, null, false);
      } else if (res.ret === 211 || res.ret === 212) {
        this.setState({
          modal: true,
          verifyCodePic: res.checkCodeUrl,
          verifyCodePicId: res.checkUUID
        });
      } else {
        Toast.info(res.msg || "发送失败", 2, null, false);
      }
    });
  };
  getVipDirect = couponIds => {
    const {
      phone,
      code,
      type,
      guideToApp,
      templateType,
      areaCode,
      activityId,
      jumpDetail
    } = this.state;
    if (!phone) {
      Toast.info("请输入正确手机号", 2, null, false);
      return;
    }
    if (!code) {
      Toast.info("请输入验证码", 2, null, false);
      return;
    }
    if (!this.state.selRules) {
      Toast.info("请阅读并同意会员协议", 2, null, false);
      return;
    }
    Toast.loading("加载中...", 10);
    let phoneArea = phone;
    if (areaCode !== "+86") {
      phoneArea = areaCode.substr(1) + "-" + phone;
    }
    registerAccountByVerifyCode(phoneArea, code).then(res => {
      if (res.ret === 0) {
        userId = res.uid;
        axios({
          url: api.GETVIP,
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Accept: "application/json, text/javascript, */*; q=0.01"
          },
          data: {
            mobile: phoneArea
          },
          params: {
            mobile: phoneArea
          }
        }).then(res => {
          const { data } = res;
          console.log(res, data.code);
          Toast.hide();
          if (data.code === 0) {
            // console.log(111, this);
            const receivedProduct = data.data;
            this.props.history.push({
              pathname: "/experience-vip/success",
              state: {
                type,
                phoneArea,
                userId,
                itemId: openItemId,
                couponIds,
                receivedProduct,
                guideToApp,
                templateType,
                activityId,
                appkey,
                jumpDetail
              }
            });
          } else {
            Toast.info(data.message || "领取失败", 2, null, false);
          }
        });
      } else {
        Toast.info(res.msg || "验证码有误", 2, null, false);
      }
    });
  };
  getVipBySign = () => {
    if (this.state.selRules) {
      const { phone, code, type, activityId, areaCode } = this.state;
      if (!phone) {
        Toast.info("请输入正确手机号", 2, null, false);
        return;
      }
      if (!code) {
        Toast.info("请输入验证码", 2, null, false);
        return;
      }
      Toast.loading("加载中...", 10);
      let phoneArea = phone;
      if (areaCode !== "+86") {
        phoneArea = areaCode.substr(1) + "-" + phone;
      }
      registerAccountByVerifyCode(phoneArea, code).then(res => {
        if (res.uid) {
          //获取uid
          const { uid } = res;
          userId = uid;
          //判断是否领取过此商品
          http
            .get(api.IS_RECEIVE_VIP, {
              itemId: mainItemId,
              uid
            })
            .then(res => {
              if (res.code !== 0) {
                Toast.info(
                  res.message || "验证是否领过会员接口出错",
                  2,
                  null,
                  false
                );
                return;
              }
              if (res.data) {
                Toast.info(
                  res.message || "您已领取过该体验会员，不能重复领取哦",
                  2,
                  null,
                  false
                );
              } else {
                // 7天和15天会员的不同参数
                let itemIdStr, vipDays;
                if (type.indexOf("7") > -1) {
                  itemIdStr = openItemId;
                  vipDays = "7";
                } else if (type.indexOf("15") > -1) {
                  itemIdStr = `${openItemId},${itemId_8day}`;
                  vipDays = "15";
                }
                //判断是否已签约自动付费包月
                http.get(api.IS_SIGNED_PAY_OPEN).then(res => {
                  Toast.hide();
                  if (res.code !== 0) {
                    Toast.info(res.msg || "未获取签约信息", 2, null, false);
                    return;
                  }
                  //statusId: 0，签约未支付成功  1，订阅中  2，已解约  null是系统未记录
                  if (res.data === 1) {
                    Toast.info("你已开通自动付费连续包月功能", 2, null, false);
                  } else {
                    window.ximali.signAndPay(itemId, {
                      returnUrl: "/",
                      discountTitle: "开通连续包月",
                      discountDesc:
                        "1.免费试用" +
                        vipDays +
                        "天，到期前一天为您自动续费18.00元/月（可取消，取消后不再自动续费；<br />2.可在“管理自动续费”中一键取消，简单方便；<br />3." +
                        "扣费前消息通知，完全透明。",
                      inAutoRenewal: false,
                      catchAlipayFailure: false, //没有打开支付宝，也不会出现微信的弹窗
                      context: {
                        appkey,
                        itemId: itemIdStr,
                        uid,
                        phone: phoneArea,
                        activityUrlId,
                        deviceId,
                        activityId
                      }
                    });
                  }
                });
              }
            });
        } else {
          Toast.info(res.msg || "注册用户失败", 2, null, false);
        }
      });
      // http   .get(`/userSubscription/byUserId/${itemId}`)   .then(res => {})
    } else {
      Toast.info("请阅读并同意会员协议", 2, null, false);
    }
  };
  getVip = e => {
    e.preventDefault();
    const { type, templateData, isNeedSign, activityId } = this.state;
    const { inputContext } = (templateData && templateData[0]) || {};
    const { couponIds } = inputContext || {};
    const statisticId = isNeedSign ? mainItemId : openItemId;
    //站外领取体验会员领取页点击立即领取
    window.xmLog("pv.send", "event", {
      serviceId: "activityPageClick",
      srcPage: "站外领取体验会员领取页",
      item: "button",
      itemId: "立即领取",
      userId,
      productId: statisticId,
      productName: type,
      appKey: appkey,
      couponId: couponIds,
      activityId
    });
    if (this.state.isNeedSign) {
      this.getVipBySign();
    } else {
      this.getVipDirect(couponIds);
    }
  };
  onClose = () => {
    this.setState({ modal: false });
  };
  submitCode = e => {
    //图片验证码
    e.preventDefault();
    const { phone, verifyCodePicId, picCode } = this.state;
    sendVerifyCode(phone, verifyCodePicId, picCode).then(res => {
      this.onClose();
      if (res.code === 0) {
        Toast.info(res.msg || "发送成功", 2, null, false);
      } else {
        Toast.info(res.msg || "发送失败，请稍后重试", 2, null, false);
      }
    });
  };
  finishedIcon = () => {
    return (
      <div className="end-pop-tip">
        <img src={require("../../assets/ballon.png")} alt="" />
        <p>活动已结束</p>
        <p>谢谢关注</p>
      </div>
    );
  };
  notStartIcon = () => {
    return (
      <div className="end-pop-tip">
        <img src={require("../../assets/ballon.png")} alt="" />
        <p>活动未开始</p>
        <p>敬请期待</p>
      </div>
    );
  };
  headerImgLoad = () => {
    const header = document.getElementById("header");
    if (header) {
      header.style.minHeight = 0;
    }
  };
  componentDidMount() {
    console.log(API_TOKEN_HOST);
    if (itemId) {
      Toast.loading("加载中...", 0);
      // http.post(API_TOKEN_HOST + api.USER_INFO).then(res => {
      //   console.log(res);
      // });
      http
        .get(api.ACTIVITYINFO, {
          itemId: openItemId,
          appkey,
          productType
        })
        .then(res => {
          Toast.hide();
          if (res && res.itemName && res.expireAt) {
            const formatDate = moment(res.expireAt).format("YYYY-MM-DD");
            const {
              status,
              enableContinueSubscribe,
              activityName,
              itemName,
              modules,
              guideToApp,
              id,
              wechatShareDesc,
              wechatShareImg,
              wechatShareTitle,
              couponDetails,
              displayStatus,
              jumpDetail
            } = res;
            const { inputContext } = (modules && modules[0]) || {};
            const { couponIds } = inputContext || {};
            // 埋点：连续包月传主站子商品ID，否则是开放平台商品ID
            window.document.getElementsByTagName(
              "title"
            )[0].innerHTML = activityName;
            const statisticId =
              enableContinueSubscribe === 1 ? mainItemId : openItemId;
            // 微信分享参数(commodity:1=vip;2=vip+coupon)
            // let shareDes = commodityType === 1 ? vipOnlyDes : vipAndCouponDes;
            // const { title, desc, imgUrl } = shareDes;
            let shareDes = {
              title: wechatShareTitle,
              desc: wechatShareDesc,
              imgUrl: wechatShareImg
            };
            new WxShare(
              {
                thirdpartyId: isTest ? 31 : 21 // 测试用31,生产使用自己真正的id(如这里是21)
              },
              shareDes
            ).init();
            // 页面曝光统计
            window.xmLog("pv.send", "event", {
              serviceId: "activityView",
              item: "站外领取体验会员领取页",
              userId,
              productId: statisticId,
              productName: itemName,
              appKey: appkey,
              couponId: couponIds,
              activityId: id
            });
            // const trackInfo = res.modules.filter(item => item.moduleType === 2);
            this.setState({
              type: itemName,
              expire: formatDate,
              isNeedSign: !!enableContinueSubscribe,
              templateType: res.templateType,
              templateData: modules,
              status,
              guideToApp,
              trackDetails: res.trackDetails || [],
              activityId: id,
              couponDetails,
              displayStatus,
              jumpDetail
            });
          } else {
            Toast.info(res.message || "活动信息有误", 2, null, false);
          }
        });
    } else {
      Toast.info("商品ID不存在", 2, null, false);
    }
  }
  handleCheckboxChange = e => {
    //console.log(e.target.checked)
    this.setState({ selRules: e.target.checked });
  };
  handleImgCompClick = data => {
    // 点击类型(0:无触发 1:跳转链接 2:弹窗)
    const { onclickEventType, link, title, content } = data || {};
    if (onclickEventType === 1) {
      window.location.href = link;
    } else if (onclickEventType === 2) {
      this.setState({
        showModal: true,
        title,
        content
      });
    } else if (onclickEventType === 3) {
      Toast.info(content, 2, null, false);
    }
  };
  onCloseModal = () => {
    this.setState({ showModal: false });
  };
  playOrPause = (playing, sound) => {
    if (playing) {
      sound.play();
    } else {
      sound.pause();
    }
  };
  playTrack = () => {
    console.log("playingInfo");
    const { curTrackInfo, playing, curTime } = this.state;
    const {
      oralTrackLocationType,
      oralTrackLocation,
      trackInfo,
      oralTrackInfo
    } = curTrackInfo;
    if (!trackInfo) {
      Toast.info("没有trackInfo声音信息", 2, null, false);
      return;
    }
    const { playPathAacv164 } = trackInfo;

    if (oralTrackInfo) {
      // 有口播声音
      if (oralTrackLocationType === 1) {
        // 开头
        if (curTime !== 0) {
          gAudio.src = playPathAacv164;
          gAudio.currentTime = curTime;
        } else {
          gAudio.src = oralTrackInfo.playPathAacv164;
          gAudio.onended = () => {
            if (gAudio.src === playPathAacv164) {
              gAudio.src = oralTrackInfo.playPathAacv164;
              gAudio.play();
            } else {
              gAudio.src = playPathAacv164;
              gAudio.play();
            }
          };
        }
      } else if (oralTrackLocationType === 2) {
        // 结尾
        gAudio.src = playPathAacv164;
        gAudio.currentTime = curTime;
        gAudio.onended = () => {
          if (gAudio.src === playPathAacv164) {
            gAudio.src = oralTrackInfo.playPathAacv164;
            gAudio.play();
          } else {
            gAudio.src = playPathAacv164;
            gAudio.play();
          }
        };
      } else if (oralTrackLocationType === 3) {
        // 自定义
        gAudio.src = playPathAacv164;
        gAudio.currentTime = curTime;
        gAudio.onended = () => {
          console.log("end666");
          if (gAudio.src === oralTrackInfo.playPathAacv164) {
            gAudio.src = playPathAacv164;
            gAudio.currentTime = oralTrackLocation + 1;
            gAudio.play();
          }
        };
      }
    } else {
      // 没口播声音
      gAudio.src = playPathAacv164;
      gAudio.currentTime = curTime;
    }
    gAudio.ontimeupdate = () => {
      if (gAudio.src === playPathAacv164) {
        const curTime = parseInt(gAudio.currentTime, 10);
        if (oralTrackLocationType === 3 && curTime === oralTrackLocation) {
          gAudio.src = oralTrackInfo.playPathAacv164;
          gAudio.play();
        }
        this.setState({ curTime });
      }
    };
    this.playOrPause(playing, gAudio);
  };
  handlePlay = item => {
    if (!item.trackInfo) {
      Toast.info("没有播放信息", 2, null, false);
      return;
    }
    const { playing } = this.state;

    this.setState(
      {
        playing: !playing,
        curTrackInfo: item
      },
      () => {
        this.playTrack();
      }
    );
  };
  setPlayProgress = (item, curPos) => {
    if (!item.trackInfo) {
      Toast.info("没有播放信息", 2, null, false);
      return;
    }
    const { duration } = item.trackInfo;
    const curTime = (parseInt(curPos, 10) / 100) * duration;
    console.log(curPos, curTime);
    this.setState({ curTrackInfo: item, curTime }, () => {
      this.playTrack();
    });
  };
  toastInfo = () => {
    const { templateType } = this.state;
    Toast.info(
      templateType === 3 || templateType === 4 ? globalToastInfo : globalToast,
      2,
      null,
      false
    );
  };
  render() {
    let curTrack = 0;
    const {
      templateType,
      templateData,
      status,
      playing,
      curTime,
      trackDetails,
      couponDetails,
      type,
      displayStatus,
      areaCode,
      selectAreaCode
    } = this.state;
    console.log(templateType);
    if (status === "") {
      // status 0已结束;1进行中;2未开始;3离线
      // 接口未返回
      return <div className="global-loading" />;
    } else if (status === 0) {
      // Toast.info(this.finishedIcon(), 0);
      return (
        <div className="global-loading finished">
          <div className="end-pop-tip">
            <div className="content">
              <img src={require("../../assets/ballon.png")} alt="" />
              <p>活动已结束</p>
              <p className="other">谢谢关注</p>
            </div>
          </div>
        </div>
      );
    } else if (status === 2) {
      return (
        <div className="global-loading not-start">
          <div className="end-pop-tip">
            <div className="content">
              <img src={require("../../assets/ballon.png")} alt="" />
              <p>活动未开始</p>
              <p className="other">敬请期待</p>
            </div>
          </div>
        </div>
      );
    }
    if (!templateType) {
      // 接口未返回
      return <div className="global-loading" />;
    } else if (templateType === 2) {
      // 2:自定义模版 1:固定模版 3:123礼包的固定模版 4:优惠券+VIP通用模板
      return (
        <div className="template-box testtt">
          {selectAreaCode && <AreaCode hideDrawer={this.hideDrawer} />}
          {templateData.map(item => {
            const {
              moduleType,
              imageContext,
              inputContext,
              trackContext,
              couponContext,
              orderNum
            } = item;
            if (moduleType === 1) {
              // 输入组件

              let { backgroundUrl, style } =
                (imageContext && imageContext[0]) || {};
              let curStyle = tempStyleDetailArr[style || 1];
              let btnText;
              let inputClassName = "ac-input " + inputCompColorArr[style || 1];
              if (inputContext) {
                const {
                  backgroundUrl,
                  componentMask,
                  componentColor,
                  receiveButtonTitle
                } = inputContext;
                curStyle = {
                  ...curStyle,
                  ...inputColorArr[componentColor],
                  ...maskBgArr[componentMask],
                  backgroundUrl
                };
                btnText = receiveButtonTitle;
                inputClassName =
                  "ac-input " + inputCompColorArr[componentColor || 1];
              } else {
                curStyle = {
                  ...curStyle,
                  backgroundUrl
                };
              }

              return (
                <div
                  key={orderNum}
                  className={inputClassName}
                  style={{
                    backgroundSize: "cover",
                    background: `url(${curStyle.backgroundUrl &&
                      curStyle.backgroundUrl.replace(
                        /http:/g,
                        ""
                      )}) no-repeat center/100% 100%`
                  }}
                >
                  <div
                    className="content"
                    style={{
                      backgroundColor: curStyle.backgroundColor
                    }}
                  >
                    <InputItem
                      type="phone"
                   
                      clear={true}
                      placeholder="请输入手机号"
                      onChange={this.onChange}
                      value={this.state.phone}
                    >
                      <AreaCodeComp
                        code={areaCode}
                        showDrawer={this.showDrawer}
                      />
                    </InputItem>
                    <div className="code">
                      <InputItem
                        clear={true}
                        onChange={this.onCodeChange}
                        value={this.state.code}
                        placeholder="验证码"
                      >
                        验证码
                      </InputItem>
                      <a
                        href=""
                        className={this.state.sending ? "sending" : ""}
                        onClick={this.getCode}
                      >
                        {this.state.btnTxt}
                      </a>
                    </div>
                    <a href="" className="btn" onClick={this.getVip}>
                      {btnText ? btnText : `免费领取${this.state.type}`}
                    </a>
                    {this.state.isNeedSign ? (
                      <div className="rules">
                        <Checkbox
                          checked={this.state.selRules}
                          onChange={this.handleCheckboxChange}
                        />
                        同意
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://m.ximalaya.com/vip/protocol/1532577537147?isAppleReview=false"
                        >
                          《会员服务协议》
                        </a>
                        和
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://m.ximalaya.com/vip/autorenew/protocol/1532577537152?isAppleReview=false"
                        >
                          《自动续费服务协议》
                        </a>
                      </div>
                    ) : (
                      <div className="rules">
                        <Checkbox
                          checked={this.state.selRules}
                          onChange={this.handleCheckboxChange}
                        />
                        同意
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://m.ximalaya.com/vip/protocol/1532577537147?isAppleReview=false"
                        >
                          《会员服务协议》
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              );
            } else if (moduleType === 0) {
              // 图片组件
              const { backgroundUrl } = imageContext[0] || {};
              // const curStyle = tempStyleDetailArr[style || 1];
              return (
                <div
                  key={orderNum}
                  className="ac-img"
                  onClick={() => {
                    this.handleImgCompClick(imageContext[0]);
                  }}
                >
                  <img src={backgroundUrl.replace(/http:/g, "")} alt="x" />
                </div>
              );
            } else if (moduleType === 2) {
              // 声音组件
              const item = trackDetails[curTrack] || {};
              curTrack++;
              const {
                backgroundUrl,
                componentMask,
                componentStyle,

                trackInfo
              } = item;
              const { duration, coverSmall, coverLarge, title, intro } =
                trackInfo || {};
              const curStyle = {
                ...maskBgArr[componentMask || 1],
                backgroundUrl
              };
              const curPos = parseInt((curTime / duration) * 100, 10);
              return (
                <div
                  key={orderNum}
                  className="ac-voice"
                  style={{
                    background: `url('${backgroundUrl.replace(
                      /http:/g,
                      ""
                    )}') no-repeat center/100% 100%`,
                    height: componentStyle === 1 ? "8.75rem" : "6.1rem"
                  }}
                >
                  <div
                    className="detail-box"
                    style={{ backgroundColor: curStyle.backgroundColor }}
                  >
                    <div className="play-logo-box">
                      <img
                        src={componentStyle === 1 ? coverLarge : coverSmall}
                        style={trackLogoSizeArr[componentStyle]}
                        alt="x"
                      />
                      {/* <Icon type="pause-circle" theme="outlined" /> */}
                      <img
                        src={playing ? pauseBtn : playBtn}
                        alt="x"
                        className="play-btn"
                        style={playLogoSizeArr[trackContext.componentStyle]}
                        onClick={() => {
                          this.handlePlay(item);
                        }}
                      />
                    </div>
                    <div className="track-detail">
                      <div
                        className="track-title"
                        style={{ color: curStyle.trackTitleColor }}
                      >
                        {title}
                      </div>
                      {componentStyle === 1 && intro && (
                        <div
                          className="track-intro"
                          style={{
                            WebkitBoxOrient: "vertical",
                            color: curStyle.trackMainColor
                          }}
                        >
                          {intro}
                        </div>
                      )}
                      <div
                        className="play-time"
                        style={{ color: curStyle.trackMainColor }}
                      >
                        <span>{formatSeconds(curTime)}</span>
                        <span>{formatSeconds(duration)}</span>
                      </div>
                      <Process
                        value={curPos}
                        play={value => {
                          this.setPlayProgress(item, value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            } else if (moduleType === 3) {
              // 优惠券组件
              const { backgroundUrl } = couponContext;
              return (
                <div
                  key={orderNum}
                  className="coupon-box"
                  onClick={() => {
                    this.handleImgCompClick(couponContext);
                  }}
                  style={{
                    background: `url(${backgroundUrl}) no-repeat top center/100% auto`
                  }}
                >
                  {couponDetails &&
                    couponDetails.map((item, i) => (
                      <Album key={i} data={item} hasBtn={true} />
                    ))}
                </div>
              );
            } else {
              return "";
            }
          })}
          <Modal
            visible={this.state.showModal}
            transparent
            maskClosable={false}
            onClose={this.onCloseModal}
            closable={true}
            title={this.state.title}
          >
            <div
              style={{
                maxHeight: "300px",
                overflow: "scroll",
                padding: "10px 0"
              }}
            >
              {this.state.content}
            </div>
          </Modal>
        </div>
      );
    } else {
      // 固定模版 1,3,(4:vip+coupon通用固定模板)
      let inputBg = inputBgInfo.sign;
      let vipDays,
        couponNums = 0;
      let btnText,
        banner = v61,
        inputBoxClass = "input-box",
        v3BtnStyle = {},
        v4ContentStyle = {},
        vipLogoCommon = vipLogo;
      let acDetailClassName = "ac-detail-info";
      if (templateType === 3) {
        inputBg = inputBgInfo.coupon;
        albumList = [album31, album32, album33, album34, album35, notice3];
        v3BtnStyle = {
          backgroundImage: "linear-gradient(71deg, #FDB871 0%, #FF6554 100%)"
        };
        inputBoxClass = "input-box input-box-v3";
        banner = banner3;
      } else if (templateType === 4) {
        inputBg = inputBgInfo.common;
        albumList = [album41, album42, album43, album44];
        v3BtnStyle = {
          backgroundImage: "linear-gradient(71deg, #FDB871 0%, #FF6554 100%)"
        };
        inputBoxClass = "input-box input-box-v3";
        banner = banner4;
        v4ContentStyle = { paddingTop: "1.45rem" };
        vipDays = type.replace(/[^0-9]/gi, "");
        couponDetails.forEach(({ couponNum }) => {
          couponNums += couponNum;
        });
      } else if (templateType === 5) {
        inputBg = inputBgInfo.inputBg5;
        albumList = [album51, album52, album53, album54, album55];
        if (displayStatus !== 1) {
          albumList = [album52, album53, album54, album55];
        }
        v3BtnStyle = {
          backgroundImage: "linear-gradient(90deg, #cd2215 0%, #ff5c1f 100%)"
        };
        inputBoxClass = "input-box input-box-v5";
        banner = banner5;
        acDetailClassName = "ac-detail-info ac-detail-info5";
        vipLogoCommon = vipLogo5;
        v4ContentStyle = { paddingTop: "1.7rem" };
        vipDays = type.replace(/[^0-9]/gi, "");
        couponDetails.forEach(({ couponNum }) => {
          couponNums += couponNum;
        });
      }
      if (templateData && templateData.length) {
        const { receiveButtonTitle } = templateData[0].inputContext;
        btnText = receiveButtonTitle;
      }
      return (
        <div className="get-by-sign-box mobx-four">
          {selectAreaCode && <AreaCode hideDrawer={this.hideDrawer} />}
          <div className="header" id="header" onClick={this.toastInfo}>
            <img
              onLoad={this.headerImgLoad}
              src={devHost + banner + "?v=v666"}
              alt="x"
            />
            {(templateType === 4 || templateType === 5) && (
              <div className={acDetailClassName}>
                {`内含${vipDays}天`}
                <img src={vipLogoCommon} alt="VIP" />
                <span className="bigger">会员体验卡</span>和{couponNums}张
                <span className="bigger">神券</span>
              </div>
            )}
          </div>
          <div className={inputBoxClass} style={inputBg}>
            <div className="content" style={v4ContentStyle}>
              <InputItem
                type="phone"
              
                clear={true}
                placeholder="请输入手机号"
                onChange={this.onChange}
                value={this.state.phone}
              >
                <AreaCodeComp code={areaCode} showDrawer={this.showDrawer} />
              </InputItem>
              <div className="code">
                <InputItem
                  clear={true}
                  onChange={this.onCodeChange}
                  value={this.state.code}
                  placeholder="验证码"
                >
                  验证码
                </InputItem>
                <a
                  href=""
                  className={this.state.sending ? "sending" : ""}
                  onClick={this.getCode}
                >
                  {this.state.btnTxt}
                </a>
              </div>
              <a
                href=""
                className="btn"
                onClick={this.getVip}
                style={v3BtnStyle}
              >
                {btnText ? btnText : `免费领取${this.state.type}`}
              </a>
              {this.state.isNeedSign ? (
                <div className="rules">
                  <Checkbox
                    checked={this.state.selRules}
                    onChange={this.handleCheckboxChange}
                  />
                  同意
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://m.ximalaya.com/vip/protocol/1532577537147?isAppleReview=false"
                  >
                    《会员服务协议》
                  </a>
                  和
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://m.ximalaya.com/vip/autorenew/protocol/1532577537152?isAppleReview=false"
                  >
                    《自动续费服务协议》
                  </a>
                </div>
              ) : (
                <div className="rules">
                  <Checkbox
                    checked={this.state.selRules}
                    onChange={this.handleCheckboxChange}
                  />
                  同意
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://m.ximalaya.com/vip/protocol/1532577537147?isAppleReview=false"
                  >
                    《会员服务协议》
                  </a>
                </div>
              )}
            </div>
          </div>
          <div onClick={this.toastInfo} className="ac-img">
            {albumList.map((item, i) => (
              <img key={i} src={devHost + item + "?v=v33333"} alt="x" />
            ))}
          </div>
          {templateType === 1 && (
            <div className="ac" onClick={this.toastInfo}>
              {/* <div className="title">
                <span>活动规则</span>
              </div> */}
              <img src={v611} alt="t" />
              <p>
                1、每位用户（同一喜马拉雅账号）只可领取一次
                {this.state.type}
                ，数量有限，先到先得。
              </p>
              <p>
                2、未注册喜马拉雅的手机号，登录时将自动注册，且代表您已同意
                <a
                  href="https://m.ximalaya.com/passport/register_rule"
                >
                  《注册协议》
                </a>
                。
              </p>
              <p>
                3、会员领取成功后即刻生效，用户可在有效期间内享受喜马拉雅会员权益。
              </p>
              {this.state.isNeedSign ? (
                <p>
                  4、会员到期前一天将为您自动续费连续包月会员18.00 元 /
                  月；连续包月会员可在“管理自动续费”中取消，取消后不再自动续费。
                </p>
              ) : (
                ""
              )}
              <p>
                {this.state.isNeedSign ? 5 : 4}
                、参与活动期间如对喜马拉雅会员相关内容有疑问，请拨打24小时客服电话：400-838-5616咨询。
              </p>
            </div>
          )}
          {templateType === 4 && (
            <div>
              <div className="coupon-box" onClick={this.toastInfo}>
                {couponDetails &&
                  couponDetails.map((item, i) => (
                    <Album key={i} data={item} hasBtn={true} />
                  ))}
              </div>
              <div className="ac-img">
                <img src={devHost + notice4 + "?v=v4"} alt="x" />
              </div>
            </div>
          )}
          {templateType === 5 && (
            <div>
              <div className="coupon-box5" onClick={this.toastInfo}>
                {couponDetails &&
                  couponDetails.map((item, i) => (
                    <Album key={i} data={item} hasBtn={true} />
                  ))}
              </div>
              <div className="ac-img">
                <img
                  src={
                    devHost +
                    (displayStatus === 1 ? notice5 : notice52) +
                    "?v=v55"
                  }
                  alt="x"
                />
              </div>
            </div>
          )}
          <Modal
            visible={this.state.modal}
            transparent
            maskClosable={true}
            onClose={this.onClose}
          >
            <div className="pop-content">
              <div className="title">
                为了您的账号安全，请输入以下图形验证码
              </div>
              <div className="pic-code">
                <InputItem
                  clear={true}
                  onChange={this.onPicCodeChange}
                  value={this.state.picCode}
                  placeholder="验证码"
                />
                <div className="img">
                  <img src={this.state.verifyCodePic} alt="x" />
                </div>
              </div>
              <a href="" onClick={this.submitCode} className="btn">
                确认
              </a>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default GetVip;



// WEBPACK FOOTER //
// ./src/pages/getVipBySign/Get.jsx